// extracted by mini-css-extract-plugin
export default {"news":"zRomI0G_","mobile":"mobile","news__link":"Hf6F53n9","main":"p6F9UW2J","desktop":"desktop","rubric":"hdDCc0F0","rubric__bg":"G_qvrtnZ","rubric__content":"lR4Vp4w0"};